let Touch = ()=>{
    let me = {};
    let touchData = {};

    me.init = ()=>{
        document.body.addEventListener("pointerdown",handleTouchDown);
        document.body.addEventListener("pointermove",handleTouchMove);
        document.body.addEventListener("pointerup",handleTouchUp);
    }

    function handleTouchDown(event){
        touchData.isDown = true;
        touchData.startX = event.clientX;
        touchData.startY = event.clientY;

        let clickTarget = event.target.closest(".handle");
        if (clickTarget && clickTarget.onClick) clickTarget.onClick(event,clickTarget);
        touchData.clickTarget = clickTarget;
        if (clickTarget && clickTarget.onDrag){
            touchData.isDragging = true;
            touchData.startX = event.clientX;
            touchData.startY = event.clientY;
        }
    }

    function handleTouchMove(event){
        if (touchData.isDragging){
            touchData.deltaX = event.clientX - touchData.startX;
            touchData.deltaY = event.clientY - touchData.startY;
            touchData.clickTarget.onDrag(touchData);
        }
    }

    function handleTouchUp(event){
        if (touchData.isDown){
            if (touchData.clickTarget && touchData.clickTarget.onUp){
                touchData.clickTarget.onUp(event,touchData.clickTarget);
            }
            touchData.isDragging = false;
        }
    }

    return me;
}

export default Touch();